import React from 'react'

import { Box } from 'widgets/Box'
import { Icon } from 'widgets/Icon'
import { Text } from 'widgets/Text'

interface Props {
  content?: string
}

export const MediaPlaceholder = ({ content = 'Upload file' }: Props) => (
  <Box
    width='100%'
    height='100%'
    align='center'
    justifyContent='center'
    padding={{ horizontal: 'smd' }}
  >
    <Icon name='upload' size={40} color='greyDark' />
    <Box margin='sm' />
    <Text numberOfLines={2} fontSize='sm' align='center' color='greyDark'>
      {content}
    </Text>
  </Box>
)
